// The entry for a space's public website (site.html). Mounts SiteApp and nothing else — no router,
// no app shell, no Supabase client — so a visitor downloads the site, not Arcos.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import SiteApp from './features/site/SiteApp.jsx';
import SandboxMark from './components/SandboxMark.jsx';
import { takeHandoffCode } from './api/handoffUrl.js';

// /api/site-page names the space it served, and on a site's own domain the root ('' — the whole
// domain) as well. Served as a bare file, the space is read from the /<space>/site address.
const served = window.__SITE__ && typeof window.__SITE__.slug === 'string' ? window.__SITE__ : null;
const match = window.location.pathname.match(/^\/([^/]+)\/site(?:\/|$)/);
const slug = served ? served.slug : match ? decodeURIComponent(match[1]) : '';
const base = served && typeof served.base === 'string' ? served.base : null;

// An admin arriving from Arcos with a sign-in to carry (api/_handoff.js): only then is the Supabase
// client loaded, and the site renders once the sign-in is in, so its edit button finds it. A visitor
// never carries a code, so a visitor still downloads none of this.
const handoffCode = takeHandoffCode(window);
const arrived = handoffCode
  ? Promise.race([
    import('./api/supabase.js').then((m) => m.signInFromHandoff(handoffCode)).catch(() => null),
    new Promise((r) => setTimeout(r, 8000)),
  ])
  : Promise.resolve();

arrived.finally(() => createRoot(document.getElementById('site-root')).render(
  <StrictMode>
    <SiteApp workspaceSlug={slug} base={base} />
    {/* The Arcos Sandbox's mark (test data only); renders nothing anywhere else. */}
    <SandboxMark />
  </StrictMode>,
));
